import placements from "./placements.json";

export type AppStorePlacement = "home_product" | "home_footer";

export function trackAppStoreClick(placement: AppStorePlacement): void {
  const endpoint = process.env.REACT_APP_HP_CLICK_ENDPOINT;
  if (!endpoint || !placements.includes(placement)) return;
  try {
    navigator.sendBeacon(endpoint, new Blob([JSON.stringify({ placement })], { type: "text/plain" }));
  } catch {
    // Metrics must never prevent navigation.
  }
}

export function initializeWebAnalytics(): void {
  const token = process.env.REACT_APP_CF_BEACON_TOKEN;
  if (!token || document.querySelector("script[data-cf-beacon]")) return;
  const script = document.createElement("script");
  script.defer = true;
  script.src = "https://static.cloudflareinsights.com/beacon.min.js";
  script.setAttribute("data-cf-beacon", JSON.stringify({ token }));
  document.head.appendChild(script);
}
